module.exports = __webpack_public_path__ + "55c0260a9e6d4d59265a2ce74ed0f5d3.svg";